export enum BookingReservationStatusEnum {
    ZERO = 'enums.bookingReservationStatus.onlineBooking',
    ONE = 'enums.bookingReservationStatus.appReservation',
    TWO = 'enums.bookingReservationStatus.onlineReservation',
    THREE = 'enums.bookingReservationStatus.cancelledBooking',
    FOUR = 'enums.bookingReservationStatus.cancelledReservation'
}
